<template>
  <div>
    <div v-if="isSmartPhone" class="child-stepper-section hidden sm:block mb-3">

      <div class="room-step-wrapper flex mt-2.5 mb-2">
        <Stepper style="max-width: 116px; min-width: 116px;" min="1" max="99" v-model="filter.roomCnt" class="counter" size="large" unit=""/>
      </div>

      <div class="input-name-title sm:mb-2">1部屋ご利用人数</div>

      <div class="adult-child-wrapper flex gap-2">
        <div class="label-name flex justify-center items-center">
          <span class="text-sm mr-2 opacity-40" style="color:#1F2021;">L</span>
          大人
        </div>
        <Stepper style="max-width: 115px; min-width: 115px;" v-model="filter.adultHeadCnt" min="1" max="99" class="counter" size="large" unit="人"/>
        <div class="label-name-choose flex justify-center items-center">/ 子ども</div>
        <a-popover v-model="showPopover" trigger="click" class="children-attach" style="background-color: #F2F2F2 ; max-width: 60px">
          <a-input
            class="input-value-children"
            size="large"
            :value="`${countTotalChildren} 人`"
            readOnly
          />
          <div slot="content" class="children-attach-content" >
            <div class="popover-block-first">
              <div class="block-first-title">小学生</div>
              <div class="block-first-content">
                <div class="set-value-group">
                  <div class="set-value-name">高学年</div>
                  <Stepper v-model="filter.exUpperGradesHeadCnt" min="0" :max="maxExUpperGradesHeadCnt" size="large" unit="人"/>
                </div>
                <div class="set-value-group">
                  <div class="set-value-name">低学年</div>
                  <Stepper v-model="filter.exLowerGradesHeadCnt" min="0" :max="maxExLowerGradesHeadCnt" size="large" unit="人"/>
                </div>
              </div>
            </div>
            <div class="popover-block-second">
              <div class="block-second-title">幼児</div>
              <div class="block-second-content">
                <div class="set-value-group">
                  <div class="set-value-name">食事・布団付</div>
                  <Stepper v-model="filter.youjiAHeadCnt" min="0" :max="maxYoujiAHeadCnt" size="large" unit="人"/>
                </div>
                <div class="set-value-group">
                  <div class="set-value-name">食事のみ</div>
                  <Stepper v-model="filter.youjiBHeadCnt" min="0" :max="maxYoujiBHeadCnt" size="large" unit="人"/>
                </div>
              </div>
            </div>
            <div class="popover-block-three">
              <div class="block-three-content">
                <div class="set-value-group">
                  <div class="set-value-name">布団のみ</div>
                  <Stepper v-model="filter.youjiCHeadCnt" min="0" :max="maxYoujiCHeadCnt" size="large" unit="人"/>
                </div>
                <div class="set-value-group">
                  <div class="set-value-name">食事・布団不要</div>
                  <Stepper v-model="filter.youjiDHeadCnt" min="0" :max="maxYoujiDHeadCnt" size="large" unit="人"/>
                </div>
              </div>
            </div>
          </div>
        </a-popover>
      </div>

    </div>

    <Modal v-else :visible="visible" @ok="handleOk" @cancel="handleCancel">
      <a-card :bordered="false">
        <div class="input-title">部屋数と人数を変更</div>
        <div class="block1">
          <div class="input-name-title">部屋数</div>
          <Stepper min="1" max="99" v-model="filter.roomCnt" class="counter" size="large" unit="部屋"/>
        </div>
        <div class="block2">
          <div class="input-name-title">1部屋ご利用人数</div>
          <div class="block2-content">
            <div class="add-people">
              <div class="label-name">大人</div>
              <Stepper v-model="filter.adultHeadCnt" min="1" max="99" class="counter" size="large" unit="人"/>
            </div>
            <div class="changeValue__choose-children">
              <div class="label-name-choose">子ども</div>
              <a-popover v-model="showPopover" trigger="click" class="children-attach" style="background-color: #F2F2F2 ; max-width: 500px">
                <a-input
                  class="input-value-children"
                  size="large"
                  :value="`${countTotalChildren} 人`"
                  readOnly
                />
                <div slot="content" class="children-attach-content" >
                  <div class="popover-block-first">
                    <div class="block-first-title">小学生</div>
                    <div class="block-first-content">
                      <div class="set-value-group">
                        <div class="set-value-name">高学年</div>
                        <Stepper v-model="filter.exUpperGradesHeadCnt" min="0" :max="maxExUpperGradesHeadCnt" size="large" unit="人"/>
                      </div>
                      <div class="set-value-group">
                        <div class="set-value-name">低学年</div>
                        <Stepper v-model="filter.exLowerGradesHeadCnt" min="0" :max="maxExLowerGradesHeadCnt" size="large" unit="人"/>
                      </div>
                    </div>
                  </div>
                  <div class="popover-block-second">
                    <div class="block-second-title">幼児</div>
                    <div class="block-second-content">
                      <div class="set-value-group">
                        <div class="set-value-name">食事・布団付</div>
                        <Stepper v-model="filter.youjiAHeadCnt" min="0" :max="maxYoujiAHeadCnt" size="large" unit="人"/>
                      </div>
                      <div class="set-value-group">
                        <div class="set-value-name">食事のみ</div>
                        <Stepper v-model="filter.youjiBHeadCnt" min="0" :max="maxYoujiBHeadCnt" size="large" unit="人"/>
                      </div>
                    </div>
                  </div>
                  <div class="popover-block-three">
                    <div class="block-three-content">
                      <div class="set-value-group">
                        <div class="set-value-name">布団のみ</div>
                        <Stepper v-model="filter.youjiCHeadCnt" min="0" :max="maxYoujiCHeadCnt" size="large" unit="人"/>
                      </div>
                      <div class="set-value-group">
                        <div class="set-value-name">食事・布団不要</div>
                        <Stepper v-model="filter.youjiDHeadCnt" min="0" :max="maxYoujiDHeadCnt" size="large" unit="人"/>
                      </div>
                    </div>
                  </div>
                </div>
              </a-popover>
            </div>
          </div>
        </div>
        <div class="sm-btn">
          <button @click="handleOk" class="c-btn btn-grey">
            決定
          </button>
        </div>
      </a-card>
    </Modal>
  </div>
</template>

<script>
import { Modal, Stepper } from '@/components/primitive'

export default {
  name: 'ChildrenAttach',
  components: {
    Modal,
    Stepper
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    filterForm: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      limitChildren: 10,
      showPopover: false,
      searchResult: null,
      total: 0,
      filter: {
        roomCnt: 1,
        numPeople: 0,
        adultHeadCnt: 0,
        exUpperGradesHeadCnt: 0,
        exLowerGradesHeadCnt: 0,
        youjiAHeadCnt: 0,
        youjiBHeadCnt: 0,
        youjiCHeadCnt: 0,
        youjiDHeadCnt: 0
      }
    }
  },
  created() {
    this.setDefaultData()
  },
  computed: {
    totalMemberChildCnt() {
      return this.countTotalChildren
    },
    maxExUpperGradesHeadCnt() {
      return Math.min(this.limitChildren - this.totalMemberChildCnt + this.filter.exUpperGradesHeadCnt, this.limitChildren)
    },
    maxExLowerGradesHeadCnt() {
      return Math.min(this.limitChildren - this.totalMemberChildCnt + this.filter.exLowerGradesHeadCnt, this.limitChildren)
    },
    maxYoujiAHeadCnt() {
      return Math.min(this.limitChildren - this.totalMemberChildCnt + this.filter.youjiAHeadCnt, this.limitChildren)
    },
    maxYoujiBHeadCnt() {
      return Math.min(this.limitChildren - this.totalMemberChildCnt + this.filter.youjiBHeadCnt, this.limitChildren)
    },
    maxYoujiCHeadCnt() {
      return Math.min(this.limitChildren - this.totalMemberChildCnt + this.filter.youjiCHeadCnt, this.limitChildren)
    },
    maxYoujiDHeadCnt() {
      return Math.min(this.limitChildren - this.totalMemberChildCnt + this.filter.youjiDHeadCnt, this.limitChildren)
    },
    countTotalChildren() {
      const {
        exUpperGradesHeadCnt,
        exLowerGradesHeadCnt,
        youjiAHeadCnt,
        youjiBHeadCnt,
        youjiCHeadCnt,
        youjiDHeadCnt
      } = this.filter
      return (
        exUpperGradesHeadCnt +
        exLowerGradesHeadCnt +
        youjiAHeadCnt +
        youjiBHeadCnt +
        youjiCHeadCnt +
        youjiDHeadCnt
      )
    },
    countTotalChild() {
      const {
        exUpperGradesHeadCnt,
        exLowerGradesHeadCnt,
        youjiAHeadCnt,
        youjiBHeadCnt
      } = this.filter
      return (
        exUpperGradesHeadCnt +
        exLowerGradesHeadCnt +
        youjiAHeadCnt +
        youjiBHeadCnt
      )
    },
    countTotalHeadChildCnt() {
      const {
        exUpperGradesHeadCnt,
        exLowerGradesHeadCnt,
        youjiAHeadCnt,
        youjiCHeadCnt
      } = this.filter
      return (
        exUpperGradesHeadCnt +
        exLowerGradesHeadCnt +
        youjiAHeadCnt +
        youjiCHeadCnt
      )
    },
    isSmartPhone() {
      return window.innerWidth <= 640
    }
  },
  updated() {
    this.searchPlan()
  },
  watch: {
    'filter.roomCnt'() {
      if (this.isSmartPhone) {
        this.handleOk()
      }
    },
    'filter.adultHeadCnt'() {
      if (this.isSmartPhone) {
        this.handleOk()
      }
    },
    countTotalChildren() {
      if (this.isSmartPhone) {
        this.handleOk()
      }
    },
  },
  methods: {
    setDefaultData() {
      Object.keys(this.filterForm).forEach((key) => {
        if(key in this.filter) {
          const val = this.filterForm[key]
          let defaultVal = 0
          if(key === 'roomCnt') {
            defaultVal = 1
          }
          this.filter[key] = val && +val > 0 ? +val : defaultVal
        }
      })
    },
    searchPlan() {
      const { menuNo } = this.$route.params

      const numPeople = {
        numPeople: this.filter.adultHeadCnt + this.countTotalChild
      }
      this.$repositories('plan').searchPlan(0, 10, menuNo, {
        ...this.filterForm, ...numPeople
      }).then(
        (result) => {
          this.searchResult = result
          this.total = result.totalItems
        }
      )
    },
    handleOk() {
      if (!this.isSmartPhone) {
        this.showPopover = false
      }
      this.filter.numPeople = this.filter.adultHeadCnt + this.countTotalHeadChildCnt
      this.$emit('ok', {
        countTotalChildren: this.countTotalChildren,
        countTotalChild: this.countTotalChild,
        searchResult: this.searchResult,
        filter: this.filter
      })
    },
    handleCancel() {
      this.showPopover = false
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./style.scss";
/deep/ .popover-contain {
  width: 450px;
}
</style>
